(function () {
  'use strict';
  var root = document.querySelector('[data-f2sp]');
  if (!root || root.getAttribute('data-f2sp-ready')) return;
  root.setAttribute('data-f2sp-ready', '1');

  function readJson(el) { try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  var CFG = readJson(root.querySelector('[data-f2sp-cfg]')) || {};
  var SRV = readJson(root.querySelector('[data-f2sp-state]')) || {};
  var LANG = String(CFG.lang || 'en'), LOC = String(CFG.locale || LANG);
  var layer = root.querySelector('[data-f2sp-layer]');
  var card = root.querySelector('[data-f2sp-card]');
  var map = root.querySelector('.f2spm__map');
  if (!layer || !card) return;

  var T = CFG.t || {};
  var BR = {
    de: { b_motorboot: 'Motorboot', b_segelboot: 'Segelboot', b_katamaran: 'Katamaran', k_kurz: 'Kurzkiel', k_lang: 'Langkiel', k_gemaessigt: 'Kielform dazwischen', wl: 'Wasserlinie', breite: 'Breite', tiefgang: 'Tiefgang', flaeche: 'Unterwasserfläche ca. {n} m²' },
    en: { b_motorboot: 'Motorboat', b_segelboot: 'Sailboat', b_katamaran: 'Catamaran', k_kurz: 'fin keel', k_lang: 'full keel', k_gemaessigt: 'keel in between', wl: 'waterline', breite: 'beam', tiefgang: 'draft', flaeche: 'underwater area approx. {n} m²' }
  };
  var TD = BR.de, TE = BR.en;
  function tf(s, m) { s = String(s); for (var k in m) { s = s.split('{' + k + '}').join(m[k]); } return s; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  var CN = CFG.countries || {};

  var KEY = 'f2sp_state', SENT = 'f2sp_sent', TTL = 3600000;
  function ssGet(k) { try { return JSON.parse(sessionStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function ssSet(k, v) { try { if (v == null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function lsGet(k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } }

  function parseNum(s) {
    var t = String(s == null ? '' : s).replace(/\s|m$/gi, '').replace(',', '.');
    if (!/^\d+(\.\d+)?$/.test(t)) return NaN;
    return parseFloat(t);
  }
  function fmtN(n, lang) { var r = Math.round(n * 10) / 10; return lang === 'de' ? String(r).replace('.', ',') : String(r); }
  function fmtD(n) { try { return new Intl.NumberFormat(LOC, { maximumFractionDigits: 1 }).format(Math.round(n * 10) / 10); } catch (e) { return fmtN(n, LANG); } }

  var KEEL = { kurz: 0.55, lang: 0.8, gemaessigt: 0.675 };
  function areaOf(k) {
    var L = k.l, B = k.b, D = k.t;
    if (!(L > 0 && B > 0 && D > 0)) return 0;
    var a;
    if (k.typ === 'motorboot') a = 0.95 * L * (B + D);
    else if (k.typ === 'katamaran') a = L * (B / 2.5 + D + 0.1);
    else a = (KEEL[k.kiel] != null ? KEEL[k.kiel] : KEEL.gemaessigt) * L * (B + D + 0.1);
    return a * 1.03;
  }
  function cleanKalk(o) {
    if (!o) return null;
    var k = { typ: o.typ, kiel: o.kiel || '', l: parseNum(o.l), b: parseNum(o.b), t: parseNum(o.t), area: parseNum(o.flaeche), monat: o.monat || '' };
    if (['motorboot', 'segelboot', 'katamaran'].indexOf(k.typ) < 0) return null;
    if (KEEL[k.kiel] == null) k.kiel = '';
    var dims = k.l > 0 && k.l <= 40 && k.b > 0 && k.b <= 15 && k.t > 0 && k.t <= 6;
    if (!dims) { k.l = k.b = k.t = NaN; }
    if (!(k.area > 0 && k.area <= 400)) k.area = dims ? areaOf(k) : NaN;
    if (!(k.area > 0)) return null;
    if (!/^\d{4}-\d{2}$/.test(k.monat)) k.monat = '';
    return k;
  }
  function hashParams() {
    var h = location.hash.replace(/^#/, ''), out = {};
    h.split('&').forEach(function (p) { var i = p.indexOf('='); if (i > 0) { try { out[decodeURIComponent(p.slice(0, i))] = decodeURIComponent(p.slice(i + 1)); } catch (e) {} } });
    return out;
  }
  function readKalk() {
    var hp = hashParams();
    var k = cleanKalk({ typ: hp.typ, kiel: hp.kiel, l: hp.l, b: hp.b, t: hp.t, flaeche: hp.flaeche, monat: hp.monat });
    if (k) return k;
    var ls = lsGet('f2_boot');
    if (ls && (!ls.ts || Date.now() - ls.ts < 15552000000)) { k = cleanKalk(ls); if (k) return k; }
    var sv = ssGet('f2k_saved'), st = sv && sv.state;
    if (st) {
      k = cleanKalk({ typ: st.bootstyp, kiel: st.kielKey, l: st.laenge, b: st.breite, t: st.tiefgang, flaeche: st.flaeche, monat: st.plan && st.plan.monat });
      if (k) return k;
    }
    var o = CFG.order;
    if (o) {
      var dm = String(o.masse || '').split(/x/i).map(function (x) { return String(x).replace(/[^\d.,]/g, ''); });
      k = cleanKalk({ typ: o.typ, kiel: o.kiel, l: dm[0], b: dm[1], t: dm[2], flaeche: String(o.flaeche || '').replace(/[^\d.,]/g, ''), monat: o.monat });
      if (k) { k.src = 'order'; return k; }
    }
    return null;
  }
  function kalkText(tx, fmt, withDims) {
    var k = S.k; if (!k) return '';
    var a = [tx['b_' + k.typ] + (k.typ === 'segelboot' && k.kiel ? ', ' + tx['k_' + k.kiel] : '')];
    if (withDims && k.l > 0) a.push(tx.wl + ' ' + fmt(k.l) + ' m, ' + tx.breite + ' ' + fmt(k.b) + ' m, ' + tx.tiefgang + ' ' + fmt(k.t) + ' m');
    a.push(tf(tx.flaeche, { n: Math.round(k.area) }));
    return a.join(', ');
  }

  var S = { done: false, pick: false, ort: '', v: {}, k: null };
  function save() { ssSet(KEY, { t: Date.now(), pick: S.pick, ort: S.ort, v: S.v, k: S.k }); }

  function monthName(key, loc) {
    var p = String(key).split('-'), x;
    try { x = new Intl.DateTimeFormat(loc, { month: 'long', year: 'numeric' }).format(new Date(+p[0], +p[1] - 1, 1)); } catch (e) { x = key; }
    return x.charAt(0).toUpperCase() + x.slice(1);
  }
  function monthShort(key, loc) {
    var p = String(key).split('-'), x;
    try { x = new Intl.DateTimeFormat(loc, { month: 'short', year: '2-digit' }).format(new Date(+p[0], +p[1] - 1, 1)).replace(/\./g, '').trim(); } catch (e) { x = p[1] + ' ' + p[0].slice(2); }
    return x.charAt(0).toUpperCase() + x.slice(1);
  }
  function months() {
    var now = new Date(), out = [], i, d, mm, key;
    var rest = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate() - now.getDate();
    for (i = (rest >= 5 ? 0 : 1); i <= 7; i++) {
      d = new Date(now.getFullYear(), now.getMonth() + i, 1); mm = d.getMonth() + 1;
      key = d.getFullYear() + '-' + (mm < 10 ? '0' : '') + mm;
      out.push([key, monthShort(key, LOC)]);
    }
    return out;
  }
  function monthLong(key, loc) { if (!key || key === 'offen') return ''; return monthName(key, loc); }
  function ortName() { return S.ort === '__other' ? String(S.v.ort_other || '').trim() : S.ort; }
  function placeLabel(n) { var ps = CFG.places || [], i; for (i = 0; i < ps.length; i++) if (ps[i].n === n) return ps[i].d || ps[i].n; return n; }
  function ortLabel() { return S.ort === '__other' ? ortName() : placeLabel(S.ort); }

  function placeOptions(cur) {
    var groups = {}, order = [];
    (CFG.places || []).forEach(function (p) {
      String(p.c || 'XX').split(',').forEach(function (c) {
        c = c.trim().toUpperCase(); if (!c) return;
        if (!groups[c]) { groups[c] = []; order.push(c); }
        groups[c].push(p);
      });
    });
    order.sort(function (a, b) { return String(CN[a] || a).localeCompare(String(CN[b] || b), LOC); });
    var h = '<option value="">' + esc(T.ort_choose) + '</option>';
    order.forEach(function (c) {
      h += '<optgroup label="' + esc(CN[c] || c) + '">' + groups[c].map(function (p) { return '<option value="' + esc(p.n) + '"' + (p.n === cur ? ' selected' : '') + '>' + esc(p.d || p.n) + '</option>'; }).join('') + '</optgroup>';
    });
    return h + '<option value="__other"' + (cur === '__other' ? ' selected' : '') + '>' + esc(T.ort_other) + '</option>';
  }
  function err(id) { return '<p class="f2sp-err" id="f2sp-' + id + '-err" hidden></p>'; }
  function fld(id, label, input, o) {
    o = o || {};
    return '<div class="f2sp-field"' + (o.attr || '') + '><label class="f2sp-lbl" for="f2sp-' + id + '">' + esc(label) + (o.opt ? ' <span>' + esc(T.opt) + '</span>' : '') + '</label>' + input +
      (o.hint ? '<p class="f2sp-hint">' + esc(o.hint) + '</p>' : '') + err(id) + '</div>';
  }
  function txtIn(id, o) {
    o = o || {};
    return '<input class="f2sp-in" id="f2sp-' + id + '" name="f2sp_' + id + '" data-f="' + id + '" type="' + (o.type || 'text') + '" autocomplete="' + (o.ac || 'off') + '"' +
      (o.ph ? ' placeholder="' + esc(o.ph) + '"' : '') + (o.im ? ' inputmode="' + o.im + '"' : '') + ' value="' + esc(S.v[id] || '') + '">';
  }

  var sendErr = '';
  function render() {
    var h = '<button type="button" class="f2sp-x" data-f2sp-close aria-label="' + esc(T.close) + '"><svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" focusable="false"><path d="M2 2l10 10M12 2L2 12" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></button>';
    if (S.done) {
      var sent = ssGet(SENT) || {}, first = sent.first || '';
      h += '<p class="f2sp-kicker">' + esc(sent.ort && !sent.other ? tf(T.forAt, { ort: sent.ort }) : T.forNone) + '</p>';
      h += '<h2 class="f2sp-prompt" id="f2sp-title" tabindex="-1">' + esc(first ? tf(T.done, { name: first }) : T.done_noname) + '</h2>';
      h += '<div class="f2sp-box f2sp-box--good"><p><b>' + esc(T.done_b) + '</b> ' + esc(sent.ort && !sent.other ? tf(T.done_t, { ort: sent.ort }) : T.done_t_other) + '</p></div>';
      h += '<button type="button" class="f2sp-btn" data-f2sp-close>' + esc(T.toMap) + '</button>';
      card.innerHTML = h;
      return;
    }
    var o = ortLabel();
    h += '<p class="f2sp-kicker">' + esc(!S.pick && o ? tf(T.forAt, { ort: o }) : T.forNone) + '</p>';
    h += '<h2 class="f2sp-prompt" id="f2sp-title" tabindex="-1">' + esc(T.title) + '</h2>';
    h += '<form class="f2sp-form" novalidate data-f2sp-form>';
    if (sendErr) h += '<div class="f2sp-box f2sp-box--warn" role="alert"><p>' + esc(sendErr) + '</p></div>';
    if (S.pick) {
      h += fld('ort', T.ort, '<select class="f2sp-in f2sp-sel" id="f2sp-ort" data-f="ort">' + placeOptions(S.ort) + '</select>');
      h += fld('ort_other', T.ort_other_lbl, txtIn('ort_other', { ac: 'address-level2' }), { attr: S.ort === '__other' ? ' data-other' : ' data-other hidden' });
    }
    h += '<div class="f2sp-row">' + fld('vn', T.vn, txtIn('vn', { ac: 'given-name' })) + fld('nn', T.nn, txtIn('nn', { ac: 'family-name' })) + '</div>';
    h += fld('mail', T.mail, txtIn('mail', { type: 'email', ac: 'email', im: 'email' }));
    h += fld('boot', T.boot, txtIn('boot', { ph: T.boot_ph }), { hint: S.k ? (S.k.src === 'order' && CFG.order ? tf(T.order_note, { order: CFG.order.name || '', txt: kalkText(T, fmtD, false) + (CFG.order.item ? ', ' + CFG.order.item : '') }) : tf(T.kalk, { txt: kalkText(T, fmtD, false) })) : '' });
    h += '<fieldset class="f2sp-set"><legend class="f2sp-lbl">' + esc(T.was) + '</legend><div class="f2sp-checks">' +
      '<label class="f2sp-tick"><input type="checkbox" data-f="rumpf"' + (S.v.rumpf ? ' checked' : '') + '><span>' + esc(T.rumpf) + '</span></label>' +
      '<label class="f2sp-tick"><input type="checkbox" data-f="prop"' + (S.v.prop ? ' checked' : '') + '><span>' + esc(T.prop) + '</span></label></div>' + err('was') + '</fieldset>';
    var ms = months(), cur = S.v.wann || '';
    if (cur && cur !== 'offen' && !ms.some(function (m) { return m[0] === cur; })) ms.push([cur, monthShort(cur, LOC)]);
    ms.push(['offen', T.offen]);
    h += '<fieldset class="f2sp-set"><legend class="f2sp-lbl" id="f2sp-wann-l">' + esc(T.wann) + '</legend><div class="f2sp-chips" role="group" aria-labelledby="f2sp-wann-l">' +
      ms.map(function (m) { var sel = cur === m[0]; return '<button type="button" class="f2sp-chip' + (sel ? ' sel' : '') + '" data-month="' + m[0] + '" aria-pressed="' + sel + '">' + esc(m[1]) + '</button>'; }).join('') +
      '</div>' + err('wann') + '</fieldset>';
    h += fld('msg', T.msg, '<textarea class="f2sp-in f2sp-ta" id="f2sp-msg" data-f="msg" rows="3" placeholder="' + esc(T.msg_ph) + '">' + esc(S.v.msg || '') + '</textarea>', { opt: true });
    h += '<label class="f2sp-check"><input type="checkbox" id="f2sp-ok" data-f="ok"' + (S.v.ok ? ' checked' : '') + '><span>' + esc(T.consent) + ' <a href="' + esc(CFG.privacy || '/policies/privacy-policy') + '" target="_blank" rel="noopener">' + esc(T.privacy) + '</a></span></label>' + err('ok');
    h += '<button type="submit" class="f2sp-btn">' + esc(T.send) + '</button></form>';
    card.innerHTML = h;
  }

  function showErr(id, msg) {
    var el = document.getElementById('f2sp-' + id + '-err'), inp = document.getElementById('f2sp-' + id);
    if (el) { el.textContent = msg || ''; el.hidden = !msg; }
    if (inp) { if (msg) { inp.setAttribute('aria-invalid', 'true'); inp.setAttribute('aria-describedby', 'f2sp-' + id + '-err'); } else inp.removeAttribute('aria-invalid'); }
    return !msg;
  }
  function val(id) { return String(S.v[id] == null ? '' : S.v[id]).trim(); }
  function validate() {
    var bad = [];
    function chk(id, msg) { if (!showErr(id, msg)) bad.push(id); }
    if (S.pick) { chk('ort', S.ort ? '' : T.e_pick); if (S.ort === '__other') chk('ort_other', val('ort_other') ? '' : T.e_req); }
    chk('vn', val('vn') ? '' : T.e_req);
    chk('nn', val('nn') ? '' : T.e_req);
    chk('mail', !val('mail') ? T.e_req : (/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(val('mail')) ? '' : T.e_mail));
    chk('boot', val('boot') ? '' : T.e_req);
    chk('was', S.v.rumpf || S.v.prop ? '' : T.e_was);
    chk('wann', val('wann') ? '' : T.e_pick);
    chk('ok', S.v.ok ? '' : T.e_ok);
    if (bad.length) {
      var el = document.getElementById('f2sp-' + bad[0]) || card.querySelector(bad[0] === 'wann' ? '[data-month]' : '[data-f="' + (bad[0] === 'was' ? 'rumpf' : bad[0]) + '"]');
      if (el && el.focus) el.focus();
      var e2 = document.getElementById('f2sp-' + bad[0] + '-err'); if (e2 && e2.scrollIntoView) e2.scrollIntoView({ block: 'nearest' });
      return false;
    }
    return true;
  }

  var open = false, pushed = false, lastTrigger = null;
  function place() {
    var inMap = map && map.clientHeight >= 560 && window.innerWidth >= 760;
    var target = inMap ? map : document.body;
    if (layer.parentNode !== target) target.appendChild(layer);
    layer.classList.toggle('is-inmap', !!inMap);
    layer.classList.toggle('is-fixed', !inMap);
    document.documentElement.classList.toggle('f2sp-lock', !inMap);
    if (inMap) {
      var off = stickyTop();
      layer.style.setProperty('--f2sp-off', off + 'px');
      var r = map.getBoundingClientRect();
      if (Math.abs(r.top - off - 8) > 24) window.scrollTo({ top: window.pageYOffset + r.top - off - 8, behavior: 'smooth' });
    }
  }
  function stickyTop() {
    var h = document.querySelector('header'), n = h, max = 0;
    while (n && n !== document.body) {
      var ps = window.getComputedStyle(n).position;
      if (ps === 'sticky' || ps === 'fixed') { max = Math.max(max, n.getBoundingClientRect().bottom); break; }
      n = n.parentElement;
    }
    return Math.max(0, Math.min(160, Math.round(max)));
  }
  function show() {
    place();
    open = true; layer.hidden = false;
    var hd = card.querySelector('#f2sp-title');
    setTimeout(function () { if (hd) { try { hd.focus({ preventScroll: true }); } catch (e) {} } }, 30);
  }
  function hide() {
    open = false; layer.hidden = true;
    document.documentElement.classList.remove('f2sp-lock');
    if (S.done) { S.done = false; ssSet(SENT, null); }
    var t = lastTrigger; lastTrigger = null;
    if (t && t.focus && document.contains(t)) { try { t.focus({ preventScroll: true }); } catch (e) {} }
  }
  function closeFlow() {
    if (pushed && history.state && history.state.f2sp) { pushed = false; history.back(); setTimeout(function () { if (open) hide(); }, 400); }
    else hide();
  }
  function pushOpen() { try { history.pushState({ f2sp: 1 }, '', location.href); pushed = true; } catch (e) {} }

  function track(name, props) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('f2_' + name, props || {}); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', name, props || {}); } catch (e) {}
  }

  function openFlow(where) {
    lastTrigger = document.activeElement;
    var st = ssGet(KEY);
    if (st && Date.now() - st.t < TTL) { S.v = st.v || {}; S.k = st.k || null; S.ort = st.ort || ''; S.pick = !!st.pick; }
    else { S.v = {}; S.k = null; S.ort = ''; S.pick = false; }
    var fresh = readKalk(); if (fresh) S.k = fresh;
    if (S.k && S.k.monat && !S.v.wann) S.v.wann = S.k.monat;
    if (CFG.order && S.v.rumpf == null && S.v.prop == null) { S.v.rumpf = true; if (CFG.order.prop) S.v.prop = true; }
    if (CFG.order && !S.v.wann && CFG.order.monat) S.v.wann = CFG.order.monat;
    var cust = CFG.customer;
    if (cust) { if (!S.v.vn && cust.first) S.v.vn = cust.first; if (!S.v.nn && cust.last) S.v.nn = cust.last; if (!S.v.mail && cust.email) S.v.mail = cust.email; }
    if (where) { S.ort = where; S.pick = false; }
    else { if (!S.pick) S.ort = ''; S.pick = true; }
    S.done = false; sendErr = '';
    save(); render(); show();
    if (!pushed) pushOpen();
    track('servicepartner_start', { ort: where || '' });
  }

  layer.addEventListener('click', function (e) {
    if (e.target === layer || e.target.closest('[data-f2sp-close]')) { closeFlow(); }
  });
  card.addEventListener('click', function (e) {
    var m = e.target.closest('[data-month]'); if (!m) return;
    S.v.wann = m.getAttribute('data-month');
    Array.prototype.forEach.call(card.querySelectorAll('[data-month]'), function (x) { x.classList.toggle('sel', x === m); x.setAttribute('aria-pressed', String(x === m)); });
    showErr('wann', ''); save();
  });
  card.addEventListener('input', function (e) {
    var f = e.target.getAttribute && e.target.getAttribute('data-f'); if (!f) return;
    if (f === 'ort') return;
    S.v[f] = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    showErr(f === 'rumpf' || f === 'prop' ? 'was' : f, ''); save();
  });
  card.addEventListener('change', function (e) {
    var f = e.target.getAttribute && e.target.getAttribute('data-f'); if (!f) return;
    if (f === 'ort') {
      S.ort = e.target.value; showErr('ort', '');
      var oth = card.querySelector('[data-other]'); if (oth) oth.hidden = S.ort !== '__other';
      var k = card.querySelector('.f2sp-kicker'); if (k) k.textContent = T.forNone;
      if (S.ort === '__other') { var oi = document.getElementById('f2sp-ort_other'); if (oi) oi.focus(); }
      save(); return;
    }
    S.v[f] = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    showErr(f === 'rumpf' || f === 'prop' ? 'was' : f, ''); save();
  });
  card.addEventListener('submit', function (e) {
    if (!e.target.hasAttribute('data-f2sp-form')) return;
    e.preventDefault();
    Array.prototype.forEach.call(e.target.querySelectorAll('[data-f]'), function (x) {
      var f = x.getAttribute('data-f'); if (f === 'ort') { S.ort = x.value; return; }
      S.v[f] = x.type === 'checkbox' ? x.checked : x.value;
    });
    save();
    if (!validate()) return;
    submit(e.target.querySelector('.f2sp-btn'));
  });
  document.addEventListener('keydown', function (e) { if (open && e.key === 'Escape') closeFlow(); });
  window.addEventListener('popstate', function () { if (open) { pushed = false; hide(); } });
  window.addEventListener('resize', function () { if (open) place(); });

  function brief(tx, lang) {
    var de = lang === 'de', L = [], o = ortName();
    L.push(de ? 'Anfrage über f2eco.eu, Servicepartner-Karte' : 'Enquiry via f2eco.eu, service partner map');
    L.push((de ? 'Ort: ' : 'Place: ') + o + (S.ort === '__other' ? (de ? ' (nicht auf der Karte)' : ' (not on the map)') : ''));
    var w = [];
    if (S.v.rumpf) w.push(de ? 'Rumpf mit F2 EcoHull' : 'hull with F2 EcoHull');
    if (S.v.prop) w.push(de ? 'Propeller mit F2 OptiProp' : 'propeller with F2 OptiProp');
    L.push((de ? 'Beschichten: ' : 'To be coated: ') + w.join(de ? ' und ' : ' and '));
    L.push((de ? 'Boot: ' : 'Boat: ') + val('boot'));
    if (S.k) L.push((S.k.src === 'order' ? (de ? 'Aus der F2-Bestellung: ' : 'From the F2 order: ') : (de ? 'Aus dem F2-Flächenrechner: ' : 'From the F2 area calculator: ')) + kalkText(tx, function (n) { return fmtN(n, lang); }, true));
    if (CFG.order && CFG.order.item) L.push((de ? 'Material: bei F2 ECO bestellt, ' : 'Material: ordered from F2 ECO, ') + CFG.order.item + (CFG.order.date ? (de ? ' am ' : ' on ') + CFG.order.date : ''));
    L.push((de ? 'Wunschtermin: ' : 'Preferred date: ') + (monthLong(val('wann'), de ? 'de-DE' : 'en-GB') || (de ? 'später oder offen' : 'later or not sure')));
    var msg = val('msg'); if (msg) L.push((de ? 'Nachricht: ' : 'Message: ') + msg);
    return L.join('\n');
  }

  function submit(btn) {
    var form = sendForm(), boxEl = form && form.querySelector('[data-f2sp-fields]');
    if (!form || !boxEl) return;
    var o = ortName(), other = S.ort === '__other';
    var F = [
      ['Anfrage', 'Werftanfrage über die Servicepartner-Karte'],
      ['Ort', other ? 'Anderer Ort: ' + o : o],
      ['name', (val('vn') + ' ' + val('nn')).trim()], ['email', val('mail')],
      ['Sprache', { de: 'Deutsch', en: 'Englisch', fr: 'Französisch', it: 'Italienisch', es: 'Spanisch', nl: 'Niederländisch', hr: 'Kroatisch' }[LANG] || LOC],
      ['Für die Werft (Deutsch)', brief(TD, 'de')],
      ['For the yard (English)', brief(TE, 'en')],
      ['Einwilligung', 'ja: ' + T.consent],
      ['Bestellung', CFG.order ? (CFG.order.name || '') + (CFG.order.date ? ' vom ' + CFG.order.date : '') : 'keine'],
      ['Seite', location.pathname],
      ['body', val('msg') || '(keine Nachricht)']
    ];
    boxEl.innerHTML = '';
    F.forEach(function (p) {
      var el = document.createElement(String(p[1]).indexOf('\n') > -1 || p[0] === 'body' ? 'textarea' : 'input');
      if (el.tagName === 'INPUT') el.type = 'hidden';
      el.name = 'contact[' + p[0] + ']'; el.value = p[1];
      boxEl.appendChild(el);
    });
    ssSet(SENT, { t: Date.now(), ort: ortLabel(), other: other, first: val('vn') });
    if (btn) { btn.disabled = true; btn.textContent = T.sending; }
    sendErr = '';
    track('servicepartner_anfrage', { ort: o, rumpf: !!S.v.rumpf, propeller: !!S.v.prop, rechnerdaten: !!S.k });
    captchaReady(form, function (ok) {
      if (!ok) { sendFailed(); return; }
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
      setTimeout(function () { if (!leaving) sendFailed(); }, 90000);
    });
  }
  var leaving = false;
  window.addEventListener('pagehide', function () { leaving = true; });
  window.addEventListener('beforeunload', function () { leaving = true; });
  function sendForm() { return CFG.formId ? document.getElementById(CFG.formId) : null; }
  function captchaOn() { return !!(window.Shopify && window.Shopify.captcha); }
  function captchaBound(form) { return form.hasAttribute('data-hcaptcha-bound') || form.hasAttribute('data-recaptcha-bound'); }
  function captchaPrime() {
    var form = sendForm();
    if (!form || !captchaOn() || captchaBound(form)) return;
    var ev;
    try { ev = new FocusEvent('focusin', { bubbles: true }); } catch (e) { ev = document.createEvent('Event'); ev.initEvent('focusin', true, false); }
    form.dispatchEvent(ev);
  }
  function captchaReady(form, cb) {
    if (!captchaOn() || captchaBound(form)) { cb(true); return; }
    captchaPrime();
    var t0 = Date.now();
    (function poll() {
      if (captchaBound(form)) { cb(true); return; }
      if (Date.now() - t0 > 20000) { cb(false); return; }
      setTimeout(poll, 150);
    })();
  }
  function sendFailed() {
    if (S.done) return;
    ssSet(SENT, null);
    sendErr = tf(T.e_send, { mail: CFG.mail || '' });
    render();
    var b = card.querySelector('.f2sp-box--warn'); if (b && b.scrollIntoView) b.scrollIntoView({ block: 'center' });
  }
  card.addEventListener('focusin', function () { captchaPrime(); });

  window.F2SPA = { open: openFlow };

  function init() {
    if (SRV.errors || SRV.posted) {
      var st = ssGet(KEY);
      if (st) { S.v = st.v || {}; S.ort = st.ort || ''; S.k = st.k || null; S.pick = !!st.pick; }
      if (/[?&]contact_posted=/.test(location.search) || location.hash === '#contact_form') {
        try { history.replaceState(null, '', location.pathname + location.hash.replace('#contact_form', '')); } catch (e) {}
      }
      if (SRV.errors) { S.done = false; sendErr = tf(T.e_send, { mail: CFG.mail || '' }) + ' (' + SRV.errors + ')'; ssSet(SENT, null); }
      else { S.done = true; ssSet(KEY, null); }
      render(); show(); pushOpen();
      return;
    }
    var q = window.F2SPAq || [];
    if (q.length) { openFlow(q[q.length - 1]); window.F2SPAq = []; return; }
    var hp = hashParams();
    if (hp.anfrage != null || hp.ort) openFlow(hp.ort || '');
  }
  init();
})();
